export const AcademicTutoringData = [
  {
    title: 'Personalized 1:1 Tutoring',
    description:
      'Match with expert tutors tailored to your child’s needs. Our personalized approach ensures focused attention and customized lesson plans for better learning outcomes.',
    img: '/images/academic-tutoring/personalized.png',
    isImageLeft: true,
  },
  {
    title: 'AI-Powered Study Guides',
    description:
      'Smart algorithms analyze strengths and weaknesses to create adaptive study plans. Students receive targeted lessons and practice tests to maximize improvement.',
    img: '/images/academic-tutoring/study-guide.png',
    isImageLeft: false,
  },
  {
    title: 'Interactive Practice Tests',
    description:
      'Access AI-generated practice questions and full-length mock tests for standardized tests. Get instant feedback and detailed performance reports to track progress effectively.',
    img: '/images/academic-tutoring/practice-test.png',
    isImageLeft: true,
  },
  {
    title: 'Seamless Scheduling & Progress Tracking',
    description:
      'Easily book sessions, communicate with tutors, and monitor progress—all in one intuitive dashboard.',
    img: '/images/academic-tutoring/progress-tracking.png',
    isImageLeft: false,
  },
  {
    title: 'See Session Recordings, Debriefs, Key Takeaways and more',
    description:
      'Never miss a moment from your tutoring sessions! Access full session recordings, detailed debriefs, and key takeaways to reinforce learning and track progress. Review past discussions, revisit important concepts, and gain deeper insights—all at your convenience.',
    img: '/images/academic-tutoring/session-recordings.png',
    isImageLeft: true,
  },
  {
    title: 'Upload Study Materials for Personalized Tutoring',
    description:
      'Help tutors create tailored learning guides by uploading lesson plans, worksheets, and notes. Providing the right resources ensures structured, engaging lessons and better student outcomes.',
    img: '/images/academic-tutoring/study-material.png',
    isImageLeft: false,
  },
];
